export default "__VITE_ASSET__CzZMR$cf__"